import styled, { css } from 'styled-components'

export const Container = styled.div<{ $bold?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: var(--space-200) 0;

  ${({ $bold }) =>
    $bold &&
    css`
      font-weight: var(--font-weight-semibold);
    `}
`

export const Text = styled.div`
  display: flex;
  align-items: center;
`

export const Cost = styled.div`
  width: 88px;
  margin-left: var(--space-400);
  text-align: right;
`
